import { render } from "./OtherDetailsMainCategoryView.vue?vue&type=template&id=9e299fa4"
import script from "./OtherDetailsMainCategoryView.vue?vue&type=script&lang=js"
export * from "./OtherDetailsMainCategoryView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__